var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCorrectTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 59.9922C10 66.5583 11.2933 73.0601 13.806 79.1264C16.3188 85.1926 20.0017 90.7046 24.6447 95.3475C29.2876 99.9904 34.7995 103.673 40.8658 106.186C46.9321 108.699 53.4339 109.992 60 109.992C66.5661 109.992 73.0679 108.699 79.1342 106.186C85.2004 103.673 90.7124 99.9904 95.3553 95.3475C99.9983 90.7046 103.681 85.1926 106.194 79.1264C108.707 73.0601 110 66.5583 110 59.9922C110 53.4261 108.707 46.9243 106.194 40.858C103.681 34.7917 99.9983 29.2798 95.3553 24.6368C90.7124 19.9939 85.2004 16.3109 79.1342 13.7982C73.0679 11.2855 66.5661 9.99219 60 9.99219C53.4339 9.99219 46.9321 11.2855 40.8658 13.7982C34.7995 16.3109 29.2876 19.9939 24.6447 24.6368C20.0017 29.2798 16.3188 34.7917 13.806 40.858C11.2933 46.9243 10 53.4261 10 59.9922Z",
    fill: "#58CC02"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3333 59.9922L54.4444 71.1033L76.6667 48.8811",
    fill: "#58CC02"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3333 59.9922L54.4444 71.1033L76.6667 48.8811M10 59.9922C10 66.5583 11.2933 73.0601 13.806 79.1264C16.3188 85.1926 20.0017 90.7046 24.6447 95.3475C29.2876 99.9904 34.7995 103.673 40.8658 106.186C46.9321 108.699 53.4339 109.992 60 109.992C66.5661 109.992 73.0679 108.699 79.1342 106.186C85.2004 103.673 90.7124 99.9904 95.3553 95.3475C99.9983 90.7046 103.681 85.1926 106.194 79.1264C108.707 73.0601 110 66.5583 110 59.9922C110 53.4261 108.707 46.9243 106.194 40.858C103.681 34.7917 99.9983 29.2798 95.3553 24.6368C90.7124 19.9939 85.2004 16.3109 79.1342 13.7982C73.0679 11.2855 66.5661 9.99219 60 9.99219C53.4339 9.99219 46.9321 11.2855 40.8658 13.7982C34.7995 16.3109 29.2876 19.9939 24.6447 24.6368C20.0017 29.2798 16.3188 34.7917 13.806 40.858C11.2933 46.9243 10 53.4261 10 59.9922Z",
    stroke: "white",
    strokeWidth: 8.57143,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M43 60L54.1466 70.662C54.343 70.8499 54.6536 70.8464 54.8458 70.6542L77.5 48",
    stroke: "white",
    strokeWidth: 9,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorrectTick);
export default __webpack_public_path__ + "static/media/correctTick.1ba5dfbbd02e3f02308d0a6970a89e88.svg";
export { ForwardRef as ReactComponent };